/* ==========================================================
   Bureaulift — comportements communs (vanilla JS)
   Tout passe par la délégation d'événements : les sections
   rechargées dans l'éditeur de thème restent fonctionnelles.
   ========================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* même rendu que le Liquid : money_without_currency + ' €' (ex. 1.234,56 €) */
  function money(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' €';
  }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function lc(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  /* ---------- Défilement doux des ancres (1,4 s) ---------- */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight) return pw;
    return null;
  }
  function smoothTo(target) {
    var box = scroller();
    var start = box ? box.scrollTop : window.pageYOffset;
    var header = document.querySelector('.bls-hbar, .bl-header');
    var offset = header ? header.offsetHeight + 8 : 0;
    var end = target.getBoundingClientRect().top - (box ? box.getBoundingClientRect().top : 0) + start - offset;
    if (box) box.style.scrollBehavior = 'auto';
    var dur = 1400, t0 = null;
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var y = start + (end - start) * ease(p);
      if (box) box.scrollTop = y; else window.scrollTo(0, y);
      if (p < 1) requestAnimationFrame(step);
      else if (box) box.style.scrollBehavior = '';
    }
    requestAnimationFrame(step);
    setTimeout(function () {
      if (t0 === null) { if (box) box.scrollTop = end; else window.scrollTo(0, end); }
    }, 150);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname || !url.hash || url.hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    var drawer = document.querySelector('[data-bl-drawer].is-open');
    if (drawer) drawer.classList.remove('is-open');
    smoothTo(target);
  });

  /* ---------- En-tête : menu burger ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bl-burger]');
    if (!b) return;
    var header = b.closest('[data-bl-header]');
    var drawer = header && header.querySelector('[data-bl-drawer]');
    if (!drawer) return;
    var open = drawer.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- WhatsApp ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bl-wa-toggle]');
    if (!t) return;
    var wa = t.closest('[data-bl-wa]');
    var panel = wa.querySelector('[data-bl-wa-panel]');
    panel.hidden = !panel.hidden;
    var badge = wa.querySelector('[data-bl-wa-badge]');
    if (badge) badge.hidden = true;
  });

  /* ---------- FAQ (indépendantes) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bl-faq] .bl-faq__btn');
    if (!btn) return;
    var item = btn.closest('[data-bl-faq]');
    var sec = item.closest('.bl-faq');
    var symOpen = (sec && sec.dataset.symOpen) || '–';
    var open = !item.classList.contains('is-open');
    if (open && sec && sec.dataset.single === 'true') {
      $all('[data-bl-faq].is-open', sec).forEach(function (it) {
        it.classList.remove('is-open');
        it.querySelector('.bl-faq__btn').setAttribute('aria-expanded', 'false');
        var sy = it.querySelector('[data-bl-faq-sym]'); if (sy) sy.textContent = '+';
      });
    }
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var sym = item.querySelector('[data-bl-faq-sym]');
    if (sym) sym.textContent = open ? symOpen : '+';
  });

  /* ---------- Accordéon fiche (une rubrique ouverte à la fois) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bl-acc] .bl-acc__btn');
    if (!btn) return;
    var item = btn.closest('[data-bl-acc]');
    var wasOpen = item.classList.contains('is-open');
    $all('[data-bl-acc]', item.parentNode).forEach(function (it) {
      it.classList.remove('is-open');
      var b = it.querySelector('.bl-acc__btn'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
  });

  /* ---------- Blocage du défilement de la page sans décalage ----------
     Masquer la barre de défilement élargit la page de sa largeur : on la remplace
     par une marge identique pour que rien ne bouge derrière la fenêtre */
  function blLockScroll(on) {
    var html = document.documentElement;
    if (on) {
      if (html.dataset.blLocked) return;
      var sbw = window.innerWidth - html.clientWidth;
      html.dataset.blLocked = '1';
      html.style.overflow = 'hidden';
      if (sbw > 0) { html.style.paddingRight = sbw + 'px'; html.style.setProperty('--bl-sbw', sbw + 'px'); }
    } else {
      delete html.dataset.blLocked;
      html.style.overflow = '';
      html.style.paddingRight = '';
      html.style.removeProperty('--bl-sbw');
    }
  }

  /* ---------- Fenêtres de réassurance ---------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-bl-ra]');
    if (card) {
      var product = card.closest('[data-bl-product]');
      var sheet = product && product.querySelector('[data-bl-sheet]');
      var tpl = card.querySelector('template[data-bl-ra-content]');
      if (!sheet || !tpl) return;
      var body = sheet.querySelector('[data-bl-sheet-body]');
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      sheet.hidden = false;
      blLockScroll(true);
      return;
    }
    var s = e.target.closest('[data-bl-sheet]');
    if (s && (e.target === s || e.target.closest('[data-bl-sheet-close]'))) {
      s.hidden = true;
      blLockScroll(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $all('[data-bl-sheet]').forEach(function (s) { s.hidden = true; });
    blLockScroll(false);
  });

  /* ---------- Carrousel photos ---------- */
  function carUpdate(car) {
    var items = $all('[data-bl-car-item]', car);
    var i = Math.max(0, Math.min(items.length - 1, Number(car.dataset.index || 0)));
    car.dataset.index = i;
    var track = car.querySelector('[data-bl-car-track]');
    var w = items[0] ? items[0].getBoundingClientRect().width + 16 : 0;
    track.style.transform = 'translateX(' + (-i * w) + 'px)';
    $all('[data-bl-car-dot]', car).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-bl-car-prev]');
    var next = e.target.closest('[data-bl-car-next]');
    if (!prev && !next) return;
    var car = (prev || next).closest('[data-bl-carousel]');
    car.dataset.index = Number(car.dataset.index || 0) + (next ? 1 : -1);
    carUpdate(car);
  });
  window.addEventListener('resize', function () { $all('[data-bl-carousel]').forEach(carUpdate); });

  /* ---------- Hero accueil : textes et images alternés ---------- */
  function heroSet(hero, kind, i) {
    var items = $all(kind === 'text' ? '[data-bl-htext]' : '[data-bl-hslide]', hero);
    var dots = $all(kind === 'text' ? '[data-bl-htext-dot]' : '[data-bl-hslide-dot]', hero);
    if (items.length < 2) return;
    var n = ((i % items.length) + items.length) % items.length;
    hero.dataset[kind] = n;
    items.forEach(function (el, k) {
      if (kind === 'text') el.hidden = k !== n; else el.classList.toggle('is-active', k === n);
    });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
  }
  function heroStart(hero) {
    if (hero._blTimers) hero._blTimers.forEach(clearInterval);
    var ti = parseFloat(hero.dataset.textInterval || 6) * 1000;
    var si = parseFloat(hero.dataset.slideInterval || 4.5) * 1000;
    hero._blTimers = [
      setInterval(function () { heroSet(hero, 'text', Number(hero.dataset.text || 0) + 1); }, ti),
      setInterval(function () { heroSet(hero, 'slide', Number(hero.dataset.slide || 0) + 1); }, si)
    ];
  }
  document.addEventListener('click', function (e) {
    var td = e.target.closest('[data-bl-htext-dot]');
    var sd = e.target.closest('[data-bl-hslide-dot]');
    if (!td && !sd) return;
    var hero = (td || sd).closest('[data-bl-hero]');
    if (td) heroSet(hero, 'text', $all('[data-bl-htext-dot]', hero).indexOf(td));
    else heroSet(hero, 'slide', $all('[data-bl-hslide-dot]', hero).indexOf(sd));
    heroStart(hero);
  });

  /* ---------- Aide au choix : 1 / 2 moteurs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bl-guide-opt]');
    if (!b) return;
    var guide = b.closest('[data-bl-guide]');
    var opt = b.dataset.blGuideOpt;
    $all('[data-bl-guide-opt]', guide).forEach(function (x) { x.classList.toggle('is-active', x === b); });
    $all('[data-v1]', guide).forEach(function (el) { el.textContent = el.dataset['v' + opt]; });
  });

  /* ---------- Bienfaits : fenêtre au clic ---------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-bl-bcard]');
    if (card) {
      var sec = card.closest('[data-bl-bcards]');
      var modal = sec.querySelector('[data-bl-modal]');
      var body = modal.querySelector('[data-bl-modal-body]');
      body.innerHTML = '';
      body.appendChild(card.querySelector('template[data-bl-bcard-content]').content.cloneNode(true));
      modal.hidden = false;
      return;
    }
    var m = e.target.closest('[data-bl-modal]');
    if (m && (e.target === m || e.target.closest('[data-bl-modal-close]'))) m.hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $all('[data-bl-modal]').forEach(function (m) { m.hidden = true; });
  });

  /* ==========================================================
     FICHE PRODUIT
     ========================================================== */
  function getProduct(el) {
    if (!el._bl) {
      var json = el.querySelector('[data-bl-product-json]');
      var data = json ? JSON.parse(json.textContent) : null;
      var input = el.querySelector('[data-bl-variant-input]');
      var vid = input ? Number(input.value) : null;
      var variant = data && (data.variants.filter(function (v) { return v.id === vid; })[0] || data.variants[0]);
      el._bl = { data: data, selected: variant ? variant.options.slice() : [], variant: variant, slide: 0 };
    }
    return el._bl;
  }

  /* Galerie */
  /* Sur mobile la scène défile au doigt (overflow-x auto) : on fait défiler au lieu de fondre */
  var MQ_MOBILE = window.matchMedia('(max-width: 819px)');
  function galScrolls(stage) {
    return !!stage && MQ_MOBILE.matches;
  }
  /* Défilement animé maison (décélération douce) : l'aimantation est coupée pendant l'animation
     pour qu'elle ne « tire » pas l'image au milieu du mouvement */
  function blAnimScroll(el, to, dur) {
    if (el._blAnim) cancelAnimationFrame(el._blAnim);
    var from = el.scrollLeft, dist = to - from;
    if (Math.abs(dist) < 1) { el.style.scrollSnapType = ''; return; }
    dur = dur || Math.min(520, 260 + Math.abs(dist) * 0.25);
    el.style.scrollSnapType = 'none';
    var t0 = null;
    function step(now) {
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / dur);
      var k = 1 - Math.pow(1 - p, 3);
      el.scrollLeft = from + dist * k;
      if (p < 1) { el._blAnim = requestAnimationFrame(step); }
      else { el._blAnim = null; el.style.scrollSnapType = ''; }
    }
    el._blAnim = requestAnimationFrame(step);
  }
  window.blAnimScroll = blAnimScroll;
  function blStopAnim(el) {
    if (el && el._blAnim) { cancelAnimationFrame(el._blAnim); el._blAnim = null; el.style.scrollSnapType = ''; }
  }
  document.addEventListener('touchstart', function (e) {
    var el = e.target.closest && e.target.closest('[data-bl-gal-stage], [data-bl-advtrack], [data-bl-lb-track], [data-bl-bcar-track]');
    blStopAnim(el);
  }, { passive: true });
  /* Images de variantes hors galerie : calque posé sur la grande image, retiré dès que le client navigue */
  function vShow(productEl, mediaId) {
    var layer = productEl.querySelector('[data-bl-vlayer]');
    if (!layer) return false;
    var hit = false;
    $all('[data-bl-vslide]', layer).forEach(function (sl) {
      var on = Number(sl.dataset.mediaId) === mediaId;
      sl.classList.toggle('is-active', on);
      if (on) { hit = true; var im = sl.querySelector('img'); if (im) im.loading = 'eager'; }
    });
    layer.classList.toggle('is-on', hit);
    return hit;
  }
  function vHide(productEl) {
    var layer = productEl && productEl.querySelector('[data-bl-vlayer].is-on');
    if (layer) layer.classList.remove('is-on');
  }
  document.addEventListener('pointerdown', function (e) {
    var fr = e.target.closest && e.target.closest('.bl-gal__frame');
    if (fr && !e.target.closest('[data-bl-gal-prev], [data-bl-gal-next]')) vHide(fr.closest('[data-bl-product]'));
  }, { passive: true });
  function galGo(productEl, index, fromScroll, instant) {
    vHide(productEl);
    var slides = $all('[data-bl-slide]', productEl);
    if (!slides.length) return;
    var n = slides.length;
    var i = ((index % n) + n) % n;
    getProduct(productEl).slide = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    $all('[data-bl-thumb]', productEl).forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      if (k === i && t.parentNode && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        var row = t.parentNode;
        if (t.offsetLeft < row.scrollLeft || t.offsetLeft + t.offsetWidth > row.scrollLeft + row.clientWidth) {
          row.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
        }
      }
    });
    $all('[data-bl-dash]', productEl).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    var stage = productEl.querySelector('[data-bl-gal-stage]');
    if (!fromScroll && galScrolls(stage) && instant) {
      stage.style.scrollBehavior = 'auto';
      stage.scrollLeft = slides[i].offsetLeft - slides[0].offsetLeft;
      stage.style.scrollBehavior = '';
    } else if (!fromScroll && galScrolls(stage)) {
      blAnimScroll(stage, slides[i].offsetLeft - slides[0].offsetLeft, Number(productEl.dataset.galSpeed) || undefined);
    }
  }
  /* Tirets mis à jour en direct pendant le défilement (une fois par image affichée) */
  document.addEventListener('scroll', function (e) {
    var stage = e.target;
    if (!stage.matches || !stage.matches('[data-bl-gal-stage]') || !galScrolls(stage) || stage._blRaf) return;
    stage._blRaf = requestAnimationFrame(function () {
      stage._blRaf = 0;
      var slides = stage.querySelectorAll('[data-bl-slide]');
      if (!slides.length) return;
      var stepW = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : stage.clientWidth;
      var best = Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / Math.max(1, stepW))));
      var p = stage.closest('[data-bl-product]');
      if (p && best !== galCurrent(p)) galGo(p, best, true);
    });
  }, true);
  function galCurrent(productEl) {
    var slides = $all('[data-bl-slide]', productEl);
    for (var k = 0; k < slides.length; k++) if (slides[k].classList.contains('is-active')) return k;
    return 0;
  }
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-bl-product]');
    if (!p) return;
    var thumb = e.target.closest('[data-bl-thumb]');
    if (thumb) { galGo(p, $all('[data-bl-thumb]', p).indexOf(thumb)); return; }
    var dash = e.target.closest('[data-bl-dash]');
    if (dash) { galGo(p, $all('[data-bl-dash]', p).indexOf(dash)); return; }
    if (e.target.closest('[data-bl-gal-prev]')) { galGo(p, galCurrent(p) - 1); return; }
    if (e.target.closest('[data-bl-gal-next]')) { galGo(p, galCurrent(p) + 1); return; }
  });
  var touchX = null;
  document.addEventListener('touchstart', function (e) {
    var st = e.target.closest('[data-bl-gal-stage]');
    if (st && !galScrolls(st)) touchX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var stage = e.target.closest('[data-bl-gal-stage]');
    if (!stage || touchX === null) return;
    var dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 40) {
      var p = stage.closest('[data-bl-product]');
      galGo(p, galCurrent(p) + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  /* Variantes */
  function findVariant(data, opts) {
    return data.variants.filter(function (v) {
      return v.options.every(function (o, k) { return o === opts[k]; });
    })[0] || null;
  }
  function bestFor(data, opts, pos) {
    var best = null, score = -1;
    data.variants.forEach(function (v) {
      if (v.options[pos] !== opts[pos]) return;
      var s = (v.available ? 100 : 0);
      v.options.forEach(function (o, k) { if (k !== pos && o === opts[k]) s += 1; });
      if (s > score) { score = s; best = v; }
    });
    return best;
  }

  function render(productEl) {
    var st = getProduct(productEl);
    var data = st.data, v = st.variant;
    if (!data || !v) return;
    var sel = st.selected;

    $all('[data-bl-option]', productEl).forEach(function (group) {
      var pos = Number(group.dataset.blOption) - 1;
      var cur = group.querySelector('[data-bl-opt-current]');
      if (cur) cur.textContent = sel[pos];
      $all('[data-bl-value]', group).forEach(function (btn) {
        var val = btn.dataset.blValue;
        btn.classList.toggle('is-active', val === sel[pos]);
        var others = sel.slice(); others[pos] = val;
        var exact = findVariant(data, others);
        // pastilles : une couleur reste cliquable si elle existe dans au moins une combinaison disponible
        // (le clic bascule alors sur cette combinaison) ; les cartes, elles, suivent les autres choix
        var isSwatch = group.dataset.style === 'swatch';
        var available = data.variants.some(function (x) {
          if (isSwatch) return x.available && x.options[pos] === val;
          return x.available && x.options[pos] === val && x.options.every(function (o, k) {
            if (k === pos) return true;
            // une option sans sélecteur affiché ne bloque pas
            return o === sel[k] || !productEl.querySelector('[data-bl-option="' + (k + 1) + '"]');
          });
        });
        btn.disabled = !available;
        if (group.dataset.style === 'swatch') {
          var nt = group.querySelector('[data-bl-swatch-note]');
          btn.title = val + (!available && nt ? ' : ' + nt.dataset.text : '');
        }
        var oos = btn.querySelector('[data-bl-oos]');
        if (oos) oos.hidden = available;
        var badge = btn.querySelector('[data-bl-badge]');
        if (badge) badge.hidden = !available;
        var priceEl = btn.querySelector('[data-bl-card-price]');
        if (priceEl) {
          var pv = exact || bestFor(data, others, pos);
          priceEl.textContent = pv ? money(pv.price) : '';
        }
        var cmpEl = btn.querySelector('[data-bl-card-compare]');
        if (cmpEl) {
          var pvc = exact || bestFor(data, others, pos);
          var showCmp = !!(pvc && pvc.compare_at_price && pvc.compare_at_price > pvc.price);
          cmpEl.hidden = !showCmp;
          cmpEl.textContent = showCmp ? money(pvc.compare_at_price) : '';
        }
      });
      // pastilles : mention « Blanc · Rupture de stock » sous les couleurs indisponibles
      var note = group.querySelector('[data-bl-swatch-note]');
      if (note) {
        var off = $all('[data-bl-value]', group).filter(function (b) { return b.disabled; }).map(function (b) { return b.dataset.blValue; });
        note.hidden = !off.length;
        var names = note.querySelector('[data-bl-swatch-note-names]');
        if (names) names.textContent = off.join(', ');
      }
    });

    $all('[data-bl-price]', productEl).forEach(function (el) { el.textContent = money(v.price); });
    $all('[data-bl-compare]', productEl).forEach(function (el) {
      var show = v.compare_at_price && v.compare_at_price > v.price;
      el.hidden = !show;
      if (show) el.textContent = money(v.compare_at_price);
    });
    $all('[data-bl-p3]', productEl).forEach(function (el) { el.textContent = money(v.price / 3); });
    $all('[data-bl-p4]', productEl).forEach(function (el) { el.textContent = money(v.price / 4); });
    var hasCmp = !!(v.compare_at_price && v.compare_at_price > v.price);
    $all('[data-bl-save]', productEl).forEach(function (el) { el.hidden = !hasCmp; });
    if (hasCmp) $all('[data-bl-pct]', productEl).forEach(function (el) { el.textContent = Math.round((1 - v.price / v.compare_at_price) * 100); });
    // bloc « Prix + onglets » (bureaulift-price-tabs.js) : badge -X % et mensualités
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    $all('[data-bl-variant-input]', productEl).forEach(function (el) { el.value = v.id; });
    $all('[data-bl-add]', productEl).forEach(function (btn) {
      btn.disabled = !v.available;
      var txt = btn.querySelector('[data-bl-add-text]');
      if (txt) txt.textContent = v.available ? btn.dataset.label + (btn.dataset.showPrice === 'false' ? '' : ' · ' + money(v.price)) : (btn.dataset.soldOut || productEl.dataset.soldOut || 'Rupture de stock');
    });

    // lignes conditionnelles [valeur]
    var selLc = sel.map(lc);
    $all('[data-bl-cond]', productEl).forEach(function (el) {
      el.hidden = selLc.indexOf(lc(el.dataset.blCond)) === -1;
    });
    // caractéristiques : une ligne conditionnelle visible remplace la ligne générale de même libellé
    var groups = {};
    $all('[data-bl-spec]', productEl).forEach(function (row) {
      (groups[row.dataset.blSpec] = groups[row.dataset.blSpec] || []).push(row);
    });
    Object.keys(groups).forEach(function (k) {
      var rows = groups[k];
      var condVisible = rows.some(function (r) { return r.dataset.blCond !== undefined && !r.hidden; });
      rows.forEach(function (r) { if (r.dataset.blCond === undefined) r.hidden = condVisible; });
    });

    if (v.featured_media && !productEl._blInitSkipMedia) {
      var slides = $all('[data-bl-slide]', productEl);
      var found = false;
      for (var i = 0; i < slides.length; i++) {
        if (Number(slides[i].dataset.mediaId) === v.featured_media.id) { galGo(productEl, i, false, !!productEl._blInit); found = true; break; }
      }
      // image de variante retirée de la galerie : on l'affiche par-dessus la grande image
      if (!found) vShow(productEl, v.featured_media.id);
    } else if (!productEl._blInitSkipMedia) {
      vHide(productEl);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bl-option] [data-bl-value]');
    if (!btn || btn.disabled) return;
    var productEl = btn.closest('[data-bl-product]');
    var st = getProduct(productEl);
    if (!st.data) return;
    var pos = Number(btn.closest('[data-bl-option]').dataset.blOption) - 1;
    var opts = st.selected.slice();
    opts[pos] = btn.dataset.blValue;
    var v = findVariant(st.data, opts);
    if (!v || !v.available) v = bestFor(st.data, opts, pos) || v;
    if (!v) return;
    st.variant = v;
    st.selected = v.options.slice();
    render(productEl);
    if (history.replaceState) {
      var u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u.toString());
    }
  });

  /* Ajout au panier */
  function updateCount(count) {
    $all('[data-bl-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bl-buy]');
    if (!form) return;
    e.preventDefault();
    var productEl = form.closest('[data-bl-product]');
    var st = getProduct(productEl);
    var main = form.querySelector('[data-bl-add]');
    var err = form.querySelector('[data-bl-error]');
    if (!st.variant || !st.variant.available) return;
    err.textContent = '';
    $all('button', form).forEach(function (b) { b.disabled = true; });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: st.variant.id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur');
        var after = productEl.dataset.afterAdd;
        if (after === 'checkout') { location.href = root + 'checkout'; return; }
        if (after === 'cart') { location.href = root + 'cart'; return; }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          updateCount(c.item_count);
          document.dispatchEvent(new CustomEvent('bl:cart-added', { detail: c }));
          var txt = main.querySelector('[data-bl-add-text]');
          if (txt) { txt.textContent = 'Ajouté ✓'; setTimeout(function () { render(productEl); }, 2000); }
          $all('button', form).forEach(function (b) { b.disabled = false; });
        });
      })
      .catch(function (error) {
        err.textContent = error.message;
        $all('button', form).forEach(function (b) { b.disabled = false; });
        render(productEl);
      });
  });

  /* ---------- Questionnaire « Comment choisir ? » (blocs Question / Réponse) ---------- */
  function quizShow(box) {
    var st = box._qs || (box._qs = { step: 0, scores: [] });
    var steps = $all('[data-bl-quiz-step]', box);
    var n = steps.length;
    steps.forEach(function (el, k) {
      el.hidden = k !== st.step;
      var pill = el.querySelector('[data-bl-quiz-pill]');
      if (pill) pill.textContent = (box.dataset.pill || 'QUESTION') + ' ' + (k + 1) + ' / ' + n;
      var bar = el.querySelector('[data-bl-quiz-bar]');
      if (bar) bar.style.width = ((k + 1) / n * 100) + '%';
      var back = el.querySelector('[data-bl-quiz-back]');
      if (back) { back.hidden = k === 0; back.textContent = box.dataset.back || '← Question précédente'; }
    });
    var done = st.step >= n;
    var total = st.scores.reduce(function (x, y) { return x + y; }, 0);
    var high = total >= (Number(box.dataset.threshold) || 4);
    $all('[data-bl-quiz-res]', box).forEach(function (r) {
      r.hidden = !done || r.dataset.blQuizRes !== (high ? 'high' : 'low');
    });
  }
  function quizSetOpen(opt, open) {
    var box = opt.querySelector('[data-bl-quiz]');
    var link = opt.querySelector('[data-bl-quiz-toggle]');
    if (!box) return;
    box.hidden = !open;
    if (link) link.textContent = open ? (link.dataset.labelClose || 'Fermer') : link.dataset.labelOpen;
    if (open) { box._qs = { step: 0, scores: [] }; quizShow(box); }
  }
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.bl-opt');
    if (!opt) return;
    var box = opt.querySelector('[data-bl-quiz]');
    if (e.target.closest('[data-bl-quiz-toggle]')) { quizSetOpen(opt, box && box.hidden); return; }
    if (!box || !box.contains(e.target)) return;
    if (!box._qs) box._qs = { step: 0, scores: [] };
    var st = box._qs;
    var pick = e.target.closest('[data-bl-quiz-pick]');
    if (pick) {
      st.scores = st.scores.slice(0, st.step);
      st.scores.push(Number(pick.dataset.score) || 0);
      st.step++; quizShow(box); return;
    }
    if (e.target.closest('[data-bl-quiz-back]')) { st.step = Math.max(0, st.step - 1); quizShow(box); return; }
    if (e.target.closest('[data-bl-quiz-restart]')) { box._qs = { step: 0, scores: [] }; quizShow(box); return; }
    var apply = e.target.closest('[data-bl-quiz-apply]');
    if (apply) {
      var val = apply.dataset.blQuizApply;
      var card = $all('[data-bl-value]', opt).filter(function (x) { return lc(x.dataset.blValue) === lc(val); })[0];
      if (card && !card.disabled) card.click();
      quizSetOpen(opt, false);
    }
  });

  /* ---------- Onglets (blocs Onglets / Onglet) ---------- */
  function tabsGo(tabs, i) {
    $all('[data-bl-tab-item]', tabs).forEach(function (item, k) {
      if (item.closest('[data-bl-tabs]') !== tabs) return;
      var on = k === i;
      var btn = item.querySelector('[data-bl-tab-btn]');
      var panel = item.querySelector('[data-bl-tab-panel]');
      if (btn) { btn.classList.toggle('is-active', on); btn.setAttribute('aria-selected', on ? 'true' : 'false'); }
      if (panel) { panel.classList.toggle('is-active', on); panel.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    });
  }
  function tabsInit(tabs) {
    var items = $all('[data-bl-tab-item]', tabs);
    var cur = -1;
    items.forEach(function (it, k) { var b = it.querySelector('[data-bl-tab-btn]'); if (b && b.classList.contains('is-active')) cur = k; });
    tabsGo(tabs, cur < 0 ? 0 : cur);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bl-tab-btn]');
    if (!btn) return;
    var tabs = btn.closest('[data-bl-tabs]');
    tabsGo(tabs, $all('[data-bl-tab-item]', tabs).indexOf(btn.closest('[data-bl-tab-item]')));
  });

  /* ---------- Carrousel d'images (bloc) : tirets, défilement automatique ---------- */
  function bcarSlides(c) { return Array.prototype.slice.call(c.querySelector('[data-bl-bcar-track]').children).filter(function (x) { return x.offsetParent !== null || x.offsetWidth; }); }
  function bcarIndex(c) {
    var track = c.querySelector('[data-bl-bcar-track]');
    var sl = bcarSlides(c);
    if (sl.length < 2) return 0;
    var stepW = sl[1].offsetLeft - sl[0].offsetLeft;
    return Math.max(0, Math.min(sl.length - 1, Math.round(track.scrollLeft / Math.max(1, stepW))));
  }
  function bcarDots(c) {
    var dots = c.querySelector('[data-bl-bcar-dots]');
    if (!dots) return;
    var n = bcarSlides(c).length;
    if (dots.children.length !== n) { dots.innerHTML = n > 1 ? new Array(n + 1).join('<span></span>') : ''; }
    var i = bcarIndex(c);
    Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  function bcarInit(c) {
    bcarDots(c);
    if (c._blTimer) clearInterval(c._blTimer);
    if (c.dataset.autoplay !== 'true') return;
    var track = c.querySelector('[data-bl-bcar-track]');
    c._blTimer = setInterval(function () {
      if (!document.body.contains(c)) { clearInterval(c._blTimer); return; }
      if (Date.now() < (c._blPause || 0) || document.hidden) return;
      var panel = c.closest('[data-bl-tab-panel]');
      if (panel && !panel.classList.contains('is-active')) return;
      var r = c.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var sl = bcarSlides(c);
      if (sl.length < 2) return;
      var next = (bcarIndex(c) + 1) % sl.length;
      blAnimScroll(track, sl[next].offsetLeft - sl[0].offsetLeft, Number(c.dataset.speed) || 650);
    }, (Number(c.dataset.interval) || 4) * 1000);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-bl-bcar-track]') || t._blRaf) return;
    t._blRaf = requestAnimationFrame(function () { t._blRaf = 0; bcarDots(t.closest('[data-bl-bcar]')); });
  }, true);
  ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var c = e.target.closest && e.target.closest('[data-bl-bcar]');
      if (c) c._blPause = Date.now() + 8000;
    }, { passive: true });
  });

  /* ---------- Vidéo de montage : lecture au clic ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-bl-video-play]');
    if (!play || play.disabled) return;
    var frame = play.closest('[data-bl-video]');
    var tpl = frame && frame.querySelector('template[data-bl-video-tpl]');
    if (!tpl) return;
    frame._blOrig = frame.innerHTML;
    frame.innerHTML = tpl.innerHTML;
    var v = frame.querySelector('video');
    if (v) { try { v.play(); } catch (err) {} }
  });

  /* ---------- Vidéo de montage : la vidéo suit l'option choisie (1 / 2 moteurs) ---------- */
  function videoSwitch(variant) {
    if (!variant || !variant.options) return;
    var sel = variant.options.map(lc);
    $all('[data-bl-video-switch]').forEach(function (sec) {
      var frames = $all('[data-bl-video]', sec);
      if (frames.length < 2) return;
      var target = frames.filter(function (f) { return sel.indexOf(lc(f.dataset.blVideoFor)) !== -1; })[0]
        || sec.querySelector('[data-bl-video-default]') || frames[0];
      frames.forEach(function (f) {
        var show = f === target;
        if (!show && f._blOrig) { f.innerHTML = f._blOrig; f._blOrig = null; } // arrête la vidéo en cours
        f.hidden = !show;
      });
    });
  }
  document.addEventListener('variant:change', function (e) { videoSwitch(e.detail && e.detail.variant); });

  /* ---------- Photos clients : visionneuse plein écran ---------- */
  function lbCount(lb) {
    var track = lb.querySelector('[data-bl-lb-track]');
    var n = track.children.length;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    lb.querySelector('[data-bl-lb-count]').textContent = (Math.min(i, n - 1) + 1) + ' / ' + n;
    return i;
  }
  function lbOpen(lb, i) {
    lb.hidden = false;
    blLockScroll(true);
    var track = lb.querySelector('[data-bl-lb-track]');
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = i * track.clientWidth;
    track.style.scrollBehavior = '';
    lbCount(lb);
    var c = lb.querySelector('[data-bl-lb-close]'); if (c) c.focus();
  }
  function lbClose(lb) { lb.hidden = true; blLockScroll(false); }
  function lbStep(lb, d) {
    var track = lb.querySelector('[data-bl-lb-track]');
    var i = Math.max(0, Math.min(track.children.length - 1, lbCount(lb) + d));
    blAnimScroll(track, i * track.clientWidth);
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-bl-photo-open]');
    if (openBtn) {
      var sec = openBtn.closest('[data-bl-photos]');
      var lb = sec && sec.querySelector('[data-bl-lb]');
      if (lb) lbOpen(lb, Number(openBtn.dataset.blPhotoOpen) || 0);
      return;
    }
    var lbEl = e.target.closest('[data-bl-lb]');
    if (!lbEl) return;
    if (e.target.closest('[data-bl-lb-close]')) { lbClose(lbEl); return; }
    if (e.target.closest('[data-bl-lb-prev]')) { lbStep(lbEl, -1); return; }
    if (e.target.closest('[data-bl-lb-next]')) { lbStep(lbEl, 1); return; }
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-bl-lb-track]')) lbCount(t.closest('[data-bl-lb]'));
  }, true);
  document.addEventListener('keydown', function (e) {
    var lb = document.querySelector('[data-bl-lb]:not([hidden])');
    if (!lb) return;
    if (e.key === 'Escape') lbClose(lb);
    else if (e.key === 'ArrowLeft') lbStep(lb, -1);
    else if (e.key === 'ArrowRight') lbStep(lb, 1);
  });

  /* ---------- Glisser à la souris sur les carrousels (le doigt défile déjà nativement) ---------- */
  var DRAG_SEL = '[data-bl-gal-stage], [data-bl-advtrack], [data-bl-lb-track], [data-bl-bcar-track]';
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest(DRAG_SEL);
    if (!el) return;
    blStopAnim(el);
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (el.scrollWidth <= el.clientWidth + 1) return;
    if (e.target.closest('button:not(.bl-gal__slide), a')) return;
    drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false, lastX: e.clientX, lastT: performance.now(), v: 0, raf: 0, nx: e.clientX };
    el.style.scrollSnapType = 'none';
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var now = performance.now();
    var dt = Math.max(1, now - drag.lastT);
    drag.v = 0.8 * ((e.clientX - drag.lastX) / dt) + 0.2 * drag.v;   // vitesse lissée (px/ms)
    drag.lastX = e.clientX; drag.lastT = now; drag.nx = e.clientX;
    if (Math.abs(e.clientX - drag.x) > 4) drag.moved = true;
    if (!drag.moved) return;
    e.preventDefault();
    if (!drag.raf) {
      var d = drag;
      d.raf = requestAnimationFrame(function () { d.raf = 0; d.el.scrollLeft = d.left - (d.nx - d.x); });
    }
  });
  function dragEnd(e) {
    if (!drag) return;
    var d = drag; drag = null;
    if (d.raf) cancelAnimationFrame(d.raf);
    var el = d.el;
    var kids = Array.prototype.filter.call(el.children, function (c) { return c.tagName !== 'TEMPLATE' && c.offsetWidth > 0; });
    if (!kids.length) { el.style.scrollSnapType = ''; return; }
    var base = kids[0].offsetLeft;
    var stepW = kids.length > 1 ? kids[1].offsetLeft - base : el.clientWidth;
    var cur = Math.max(0, Math.min(kids.length - 1, Math.round(d.left / Math.max(1, stepW))));
    var dx = (e && typeof e.clientX === 'number' ? e.clientX : d.nx) - d.x;
    var fling = performance.now() - d.lastT < 80 ? d.v : 0;
    var target = cur;
    if (dx < -40 || fling < -0.35) target = Math.min(kids.length - 1, cur + 1);
    else if (dx > 40 || fling > 0.35) target = Math.max(0, cur - 1);
    blAnimScroll(el, kids[target].offsetLeft - base);
    if (d.moved) {
      // le clic qui suit un glissé ne doit rien ouvrir
      var stopClick = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      document.addEventListener('click', stopClick, true);
      setTimeout(function () { document.removeEventListener('click', stopClick, true); }, 0);
    }
  }
  document.addEventListener('pointerup', dragEnd);
  document.addEventListener('pointercancel', dragEnd);
  document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest(DRAG_SEL)) e.preventDefault(); });

  /* ---------- Initialisation ---------- */
  function init(ctx) {
    $all('[data-bl-product]', ctx).forEach(function (p) {
      p._bl = null;
      var st = getProduct(p);
      // à l'ouverture : 1re image, sauf si l'adresse demande une variante précise
      var askVariant = /[?&]variant=/.test(location.search);
      galGo(p, askVariant ? galCurrent(p) : 0, false, true);
      p._blInitSkipMedia = !askVariant;
      p._blInit = true;
      if (st.data) render(p);
      p._blInit = false;
      p._blInitSkipMedia = false;
    });
    $all('[data-bl-carousel]', ctx).forEach(carUpdate);
    $all('[data-bl-hero]', ctx).forEach(heroStart);
    $all('[data-bl-tabs]', ctx).forEach(tabsInit);
    $all('[data-bl-bcar]', ctx).forEach(bcarInit);
    $all('[data-bl-quiz]:not([hidden])', ctx).forEach(quizShow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Éditeur : un bloc sélectionné s'affiche (onglet ouvert, questionnaire ouvert sur sa question)
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var item = el.closest && el.closest('[data-bl-tab-item]');
    if (item) { var tabs = item.closest('[data-bl-tabs]'); tabsGo(tabs, $all('[data-bl-tab-item]', tabs).indexOf(item)); }
    var box = el.closest && el.closest('[data-bl-quiz]');
    if (box) {
      var opt = box.closest('.bl-opt');
      if (box.hidden && opt) quizSetOpen(opt, true);
      var step = el.closest('[data-bl-quiz-step]');
      if (step) { box._qs = { step: $all('[data-bl-quiz-step]', box).indexOf(step), scores: [] }; quizShow(box); }
    }
    $all('[data-bl-bcar]', el.closest('[data-bl-product]') || document).forEach(bcarDots);
  });
})();
